/*
* Autogenerated
*
* DO NOT EDIT DIRECTLY
*/

const opts = {registry: {}};
const isNode = typeof navigator == "undefined" ? true : false;

var custReq = eval('typeof require == "function" ? require : function(){}');

function getAvro(){
  if(isNode)
    return custReq("avsc");
  else
    return require("./avsc.js");
}

const avro = getAvro();

const IPEndPoint = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"IPEndPoint","type":"record","fields":[{"name":"ip","type":"string"},{"name":"port","type":"int"}]}, opts);

const ByteArray = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"ByteArray","type":"record","fields":[{"name":"buff","type":"bytes"}]}, opts);

const UDPMsg = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"UDPMsg","type":"record","fields":[{"name":"ep","type":["com.hps.schemas.IPEndPoint"]},{"name":"payload","type":["com.hps.schemas.ByteArray"]}]}, opts);

const RideId = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"RideId","type":"record","fields":[{"name":"value","type":["null","long"]}]}, opts);

const Event = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"Event","type":"record","fields":[{"name":"devid","type":"int"},{"name":"rideid","type":"long"},{"name":"lat","type":["null","double"]},{"name":"lng","type":["null","double"]},{"name":"alt","type":["null","float"]},{"name":"spd","type":["null","float"]},{"name":"brg","type":["null","float"]},{"name":"ang","type":["null","float"]},{"name":"hepe","type":["null","float"]},{"name":"vepe","type":["null","float"]},{"name":"temp","type":"float"},{"name":"motion","type":"boolean"},{"name":"ignition","type":"boolean"},{"name":"mainPower","type":"boolean"},{"name":"relayState","type":"boolean"},{"name":"ts","type":"long"}]}, opts);

const EventCount = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"EventCount","type":"record","fields":[{"name":"rideid","type":["null","long"]},{"name":"count","type":["null","int"]}]}, opts);

const QueryBasic = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QueryBasic","type":"record","fields":[{"name":"devid","type":["null","int"]},{"name":"rideid","type":["null","long"]},{"name":"count","type":["null","int"]},{"name":"offset","type":["null","int"]},{"name":"tsFr","type":["null","long"]},{"name":"tsTo","type":["null","long"]}]}, opts);

const QueryAdvanced = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QueryAdvanced","type":"record","fields":[{"name":"basic","type":"com.hps.schemas.QueryBasic"},{"name":"latFr","type":["null","double"]},{"name":"latTo","type":["null","double"]},{"name":"lngFr","type":["null","double"]},{"name":"lngTo","type":["null","double"]},{"name":"altFr","type":["null","float"]},{"name":"altTo","type":["null","float"]},{"name":"spdFr","type":["null","float"]},{"name":"spdTo","type":["null","float"]},{"name":"brgFr","type":["null","float"]},{"name":"brgTo","type":["null","float"]},{"name":"angFr","type":["null","float"]},{"name":"angTo","type":["null","float"]},{"name":"hepeFr","type":["null","float"]},{"name":"hepeTo","type":["null","float"]},{"name":"vepeFr","type":["null","float"]},{"name":"vepeTo","type":["null","float"]},{"name":"tempFr","type":["null","float"]},{"name":"tempTo","type":["null","float"]},{"name":"motion","type":["null","boolean"]},{"name":"ignition","type":["null","boolean"]},{"name":"mainPower","type":["null","boolean"]},{"name":"relayState","type":["null","boolean"]}]}, opts);

const EQ_OP = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"EQ_OP","type":"record","fields":[{"name":"op","type":"string"},{"name":"qnm","type":"string"},{"name":"cnt","type":["null","int"]},{"name":"buf","type":["null","bytes"]},{"name":"str","type":["null","string"]},{"name":"obj","type":["null","string"]}]}, opts);

const ALBEvent = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"ALBEvent","type":"record","fields":[{"name":"rideid","type":"long"},{"name":"lat","type":["null","double"]},{"name":"lng","type":["null","double"]},{"name":"ts","type":"long"},{"name":"spd","type":["null","float"]},{"name":"hepe","type":["null","float"]}]}, opts);

const WSMsg = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"WSMsg","type":"record","fields":[{"name":"lat","type":["null","double"]},{"name":"lng","type":["null","double"]},{"name":"ts","type":"long"},{"name":"spd","type":["null","float"]},{"name":"hepe","type":["null","float"]}]}, opts);

const TPEvent = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"TPEvent","type":"record","fields":[{"name":"devid","type":"int"},{"name":"rideid","type":"long"},{"name":"lat","type":["null","double"]},{"name":"lng","type":["null","double"]},{"name":"alt","type":["null","float"]},{"name":"spd","type":["null","float"]},{"name":"brg","type":["null","float"]},{"name":"motion","type":["null","boolean"]},{"name":"ignition","type":["null","boolean"]},{"name":"mainPower","type":["null","boolean"]},{"name":"ts","type":"long"},{"name":"xt","type":["null","bytes"]}]}, opts);

const Loc_Event = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"Loc_Event","type":"record","fields":[{"name":"vid","type":"int"},{"name":"lat","type":["null","double"]},{"name":"lng","type":["null","double"]},{"name":"alt","type":["null","float"]},{"name":"spd","type":["null","float"]},{"name":"brg","type":["null","float"]},{"name":"ang","type":["null","float"]},{"name":"hepe","type":["null","float"]},{"name":"vepe","type":["null","float"]},{"name":"temp","type":"float"},{"name":"motion","type":"boolean"},{"name":"ignition","type":"boolean"},{"name":"mainPower","type":"boolean"},{"name":"relayState","type":"boolean"},{"name":"ts","type":"long"}]}, opts);

const TimelineEvent = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"TimelineEvent","type":"record","fields":[{"name":"vid","type":"int"},{"name":"t","type":"int"},{"name":"wts","type":"long"},{"name":"ts","type":"long"},{"name":"src","type":"int"},{"name":"lat","type":["null","double"]},{"name":"lng","type":["null","double"]},{"name":"app","type":"boolean"},{"name":"meta","type":["null","bytes"]}]}, opts);

const PseudoEvent = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"PseudoEvent","type":"record","fields":[{"name":"vid","type":"int"},{"name":"tsFr","type":"long"},{"name":"tsTo","type":"long"},{"name":"t","type":"int"},{"name":"wts","type":"long"}]}, opts);

const FallAlert = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"FallAlert","type":"record","fields":[{"name":"cdt","type":["null","long"]},{"name":"ang","type":["null","float"]}]}, opts);

const SpeedAlertEvent = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"SpeedAlertEvent","type":"record","fields":[{"name":"spd","type":["null","int"]},{"name":"thresh","type":["null","int"]},{"name":"tid","type":"int"}]}, opts);

const SMSStatus = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"SMSStatus","type":"record","fields":[{"name":"status","type":"int"}]}, opts);

const Geofence = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"Geofence","type":"record","fields":[{"name":"igf","type":"boolean"},{"name":"tid","type":"int"}]}, opts);

const VoltageChange = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"VoltageChange","type":"record","fields":[{"name":"voltLvl","type":"int"}]}, opts);

const ExternalVoltageChange = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"ExternalVoltageChange","type":"record","fields":[{"name":"externalVolt","type":"float"}]}, opts);

const SafeParking = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"SafeParking","type":"record","fields":[{"name":"tId","type":"int"},{"name":"notifTypes","type":"string"},{"name":"gfIds","type":["null","string"]},{"name":"sts","type":"long"},{"name":"ets","type":["null","long"]},{"name":"spTyp","type":"int"},{"name":"ignition","type":"boolean"},{"name":"tGf","type":["null","int"]}]}, opts);

const QRequestHeader = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QRequestHeader","type":"record","fields":[{"name":"reqId","type":"int"},{"name":"qname","type":"string"}]}, opts);

const QRequestFilter = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QRequestFilter","type":"record","fields":[{"name":"header","type":"com.hps.schemas.QRequestHeader"},{"name":"data","type":"com.hps.schemas.QueryBasic"}]}, opts);

const QRequestFilterAdvanced = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QRequestFilterAdvanced","type":"record","fields":[{"name":"header","type":"com.hps.schemas.QRequestHeader"},{"name":"data","type":"com.hps.schemas.QueryAdvanced"}]}, opts);

const QRequestEventCount = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QRequestEventCount","type":"record","fields":[{"name":"header","type":"com.hps.schemas.QRequestHeader"},{"name":"rideid","type":["null","long"]}]}, opts);

const QResponseHeader = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QResponseHeader","type":"record","fields":[{"name":"reqId","type":"int"}]}, opts);

const QResponseFilter = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QResponseFilter","type":"record","fields":[{"name":"header","type":"com.hps.schemas.QResponseHeader"},{"name":"data","type":["null","com.hps.schemas.Event"]}]}, opts);

const QResponseEventCount = avro.Type.forSchema({"namespace":"com.hps.schemas","name":"QResponseEventCount","type":"record","fields":[{"name":"header","type":"com.hps.schemas.QResponseHeader"},{"name":"data","type":["null","com.hps.schemas.EventCount"]}]}, opts);

const SCHEMA = {
  Q_REQ_FILTER:{id: 1, type: QRequestFilter},
  Q_REQ_FILTER_ADVANCED:{id: 2, type: QRequestFilterAdvanced},
  Q_REQ_INSERT:{id: 3, type: Event},
  Q_REQ_DELETE:{id: 4, type: QueryBasic},
  Q_REQ_EVENT_COUNT:{id: 5, type: QRequestEventCount},
  Q_RES_FILTER:{id: 6, type: QResponseFilter},
  Q_RES_EVENT_COUNT:{id: 7, type: QResponseEventCount},
  Q_REQ_INSERT_LOC_EVT:{id: 8, type: Loc_Event},
  Q_REQ_TIMELINE_EVENT:{id: 9, type: TimelineEvent},
  A_REQ_FILTER:{id: 51, type: QueryBasic},
  A_REQ_FILTER_ADVANCED:{id: 52, type: QueryAdvanced},
  A_REQ_EVENT_COUNT:{id: 55, type: RideId},
  A_RES_FILTER:{id: 56, type: Event},
  A_EVENT_REAL_TIME:{id: 57, type: Event},
  A_RES_EVENT_COUNT:{id: 58, type: EventCount},
  ALB_RES_FILTER:{id: 59, type: ALBEvent},
  ALB_EVENT_REAL_TIME:{id: 60, type: ALBEvent},
  TP_EVENT_RT:{id: 61, type: TPEvent},
  A_LOC_EVT_RES_FILTER:{id: 62, type: Loc_Event},
  A_LOC_EVT_REAL_TIME:{id: 63, type: Loc_Event},
  A_REQ_TIMELINE_EVENT:{id: 64, type: TimelineEvent},
  A_TIMELINE_EVENT_REAL_TIME:{id: 65, type: TimelineEvent},
  A_REQ_PSEUDO_EVENT:{id: 66, type: PseudoEvent},
  A_REQ_FALL_ALERT:{id: 67, type: FallAlert},
  A_REQ_SPEED_ALERT_EVENT:{id: 68, type: SpeedAlertEvent},
  A_REQ_SMS_STATUS:{id: 69, type: SMSStatus},
  A_REQ_GEOFENCE:{id: 70, type: Geofence},
  A_REQ_SAFE_PARK:{id: 204, type: SafeParking},
  U_MSG:{id: 71, type: ByteArray},
  U_IN_MSG:{id: 72, type: UDPMsg},
  U_OUT_MSG:{id: 73, type: UDPMsg},
  ALB_IN_MSG:{id: 74, type: WSMsg},
  R_EQ_OP:{id: 101, type: EQ_OP},
  W_VOLTAGE_CHANGE_META:{id: 201, type: VoltageChange},
  W_EXTERNAL_VOLTAGE_CHANGE_META:{id: 202, type: ExternalVoltageChange},
}

const ID2SCHEMA = {
  1: SCHEMA.Q_REQ_FILTER,
  2: SCHEMA.Q_REQ_FILTER_ADVANCED,
  3: SCHEMA.Q_REQ_INSERT,
  4: SCHEMA.Q_REQ_DELETE,
  5: SCHEMA.Q_REQ_EVENT_COUNT,
  6: SCHEMA.Q_RES_FILTER,
  7: SCHEMA.Q_RES_EVENT_COUNT,
  8: SCHEMA.Q_REQ_INSERT_LOC_EVT,
  9: SCHEMA.Q_REQ_TIMELINE_EVENT,
  51: SCHEMA.A_REQ_FILTER,
  52: SCHEMA.A_REQ_FILTER_ADVANCED,
  55: SCHEMA.A_REQ_EVENT_COUNT,
  56: SCHEMA.A_RES_FILTER,
  57: SCHEMA.A_EVENT_REAL_TIME,
  58: SCHEMA.A_RES_EVENT_COUNT,
  59: SCHEMA.ALB_RES_FILTER,
  60: SCHEMA.ALB_EVENT_REAL_TIME,
  61: SCHEMA.TP_EVENT_RT,
  62: SCHEMA.A_LOC_EVT_RES_FILTER,
  63: SCHEMA.A_LOC_EVT_REAL_TIME,
  64: SCHEMA.A_REQ_TIMELINE_EVENT,
  65: SCHEMA.A_TIMELINE_EVENT_REAL_TIME,
  66: SCHEMA.A_REQ_PSEUDO_EVENT,
  67: SCHEMA.A_REQ_FALL_ALERT,
  68: SCHEMA.A_REQ_SPEED_ALERT_EVENT,
  69: SCHEMA.A_REQ_SMS_STATUS,
  70: SCHEMA.A_REQ_GEOFENCE,
  204: SCHEMA.A_REQ_SAFE_PARK,
  71: SCHEMA.U_MSG,
  72: SCHEMA.U_IN_MSG,
  73: SCHEMA.U_OUT_MSG,
  74: SCHEMA.ALB_IN_MSG,
  101: SCHEMA.R_EQ_OP,
  201: SCHEMA.W_VOLTAGE_CHANGE_META,
  202: SCHEMA.W_EXTERNAL_VOLTAGE_CHANGE_META,
}

const BUFF_SIZE = 10240;
const MAGIC_BYTES_SIZE = 2;
var buf;
if(isNode){
  buf = new Buffer(BUFF_SIZE);
}
else{
  buf = new Uint8Array(new ArrayBuffer(BUFF_SIZE));
  buf.__proto__ = Object.getPrototypeOf(Event.toBuffer(Event.random()));
}

function Encode(obj, schema) {
  if(!schema || !schema.id || !schema.type) return;

  buf.writeInt16BE(schema.id, 0);
  var pos = schema.type.encode(obj, buf, MAGIC_BYTES_SIZE);
  if(pos < 0){
    throw new Error("The buffer was too short, we need to resize :(");
  }
  return isNode ? Buffer.from(buf.slice(0, pos)) : buf.buffer.slice(0, pos);
}

function Decode(buffer){
  if(!buffer || buffer.byteLength <= 0) return;
  if(!isNode){
    buffer = new Uint8Array(buffer);
    buffer.__proto__ = buf.__proto__;
  }
  var schema = getSchema(buffer);
  if(schema)
    return {
      schema: schema,
      obj: schema.type.decode(buffer, MAGIC_BYTES_SIZE).value,
    }
}

function getSchema(buffer){
  return ID2SCHEMA[buffer.readInt16BE(0)];
}

module.exports = {
  Encode: Encode,
  Decode: Decode,
  SCHEMA: SCHEMA,
  GetSchema: getSchema
}
